import { MultiVoucherUsageDetailLeftPanelSide } from 'app/src/features/Shopping/Direct/MultiVoucherUsageDetail/components/MultiVoucherUsageDetailLeftPanelSide'
import { MultiVoucherUsageDetailRightPanelSide } from 'app/src/features/Shopping/Direct/MultiVoucherUsageDetail/components/MultiVoucherUsageDetailRightPanelSide'
import { BuildBeneficiaries } from 'app/src/features/Shopping/shared'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { DownloadFileButton } from 'app/src/shared/components'
import { euroFormatterIt, formatDate } from 'app/src/shared/helpers'
import { useTranslation } from 'react-i18next'

function renderErrorBox(order: shoppingApi.OrderDetails) {
  const castDetails = order.purchaseDetails as shoppingApi.OrderDetailsVoucherUsage

  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher.Usage.Detail' })
  switch (order.status) {
    case 'rejected':
    case 'refused':
      return (
        <div className='mt-[30px]'>
          <div className='flex flex-col bg-[#EAEAEA] p-[20px]'>
            <div className='mt-[10px] text-sm font-normal'>
              <div className='font-bold' dangerouslySetInnerHTML={{ __html: t('koOutcomeMessage') }} />
            </div>
            {castDetails?.message && (
              <>
                <div
                  className='mt-[10px] text-base font-normal'
                  dangerouslySetInnerHTML={{ __html: t('koOutcomeWithReasonMessage') }}
                />
                <div className='mt-[10px] text-base font-normal'>{castDetails.message}</div>
              </>
            )}
          </div>
        </div>
      )
    default:
      return <></>
  }
}

export function MultiVoucherUsageDetailPage(props: { order: shoppingApi.OrderDetails }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher.Usage' })

  const castDetails = props.order.purchaseDetails as shoppingApi.OrderDetailsVoucherUsage

  return (
    <div className='mx-auto max-w-5xl'>
      <h1 className='welfareportal-titlecenter'>{t('Detail.title')}</h1>
      <div className='card grid grid-cols-1 divide-x-0 divide-y-2 p-5 lg:grid-cols-12 lg:divide-x-2 lg:divide-y-0'>
        <MultiVoucherUsageDetailLeftPanelSide order={props.order} />
        <MultiVoucherUsageDetailRightPanelSide order={props.order} requestedRefund={props.order.priceDetails?.grossPrice} />
      </div>
      {renderErrorBox(props.order)}
      {castDetails && (
        <>
          <div className='mt-4 grid rounded-md bg-[var(--card-background)] p-4'>
            <div className='mt-2 grid grid-cols-1 md:grid-cols-2 lg:mt-4 lg:grid-cols-3'>
              <div className='mt-2 grid-rows-2'>
                <div className='uppercase'>{t('Detail.buyerDescription')}</div>
                <div className='mt-2'>
                  <h3>{BuildBeneficiaries(props.order)}</h3>
                </div>
              </div>
              <div className='mt-2 grid-rows-2'>
                <div className='uppercase'>{t('Detail.detailDateDescription')}</div>
                <div className='mt-2'>
                  <h3>{formatDate(castDetails.purchaseDate)}</h3>
                </div>
              </div>
              <div className='mt-2 grid-rows-2'>
                <div className='uppercase'>{t('Detail.documentNumberDescription')}</div>
                <div className='mt-2'>
                  <h3 className='lowercase'>{castDetails.invoiceId}</h3>
                </div>
              </div>
            </div>
            <div className='mt-2 grid grid-cols-1 md:grid-cols-2 lg:mt-4 lg:grid-cols-3'>
              <div className='mt-2 grid-rows-2'>
                <div className='uppercase'>{t('Detail.documentDateDescription')}</div>
                <div className='mt-2'>
                  <h3>{formatDate(castDetails.invoiceDate)}</h3>
                </div>
              </div>
              <div className='mt-2 grid-rows-2'>
                <div className='uppercase'>{t('Detail.documentExpirationDescription')}</div>
                <div className='mt-2'>
                  <h3 className='lowercase'>{formatDate(castDetails.dueDate)}</h3>
                </div>
              </div>
              <div className='mt-2 grid-rows-2'>
                <div className='uppercase'>
                  {t('Kinds')[castDetails.refundKind ?? ''].SubCategories?.[castDetails.subCategoryId].contractIdLabel}
                </div>
                <div className='mt-2'>
                  <h3 className='lowercase'>{castDetails.contractId}</h3>
                </div>
              </div>
            </div>
            <div className='mt-2 grid grid-cols-1 md:grid-cols-2 lg:mt-4 lg:grid-cols-3'>
              <div className='mt-2 grid-rows-2'>
                <div className='uppercase'>{t('Detail.documentAmountDescription')}</div>
                <div className='mt-2'>
                  <h3>{euroFormatterIt.format(castDetails.invoiceTotal)}</h3>
                </div>
              </div>
            </div>
          </div>
          {castDetails?.fileURL && castDetails?.filename && (
            <>
              <div className='mt-8 font-bold'>{t('Detail.invoiceDescription')}</div>
              <DownloadFileButton
                buttonLabel={castDetails.filename}
                fileLink={'.' + castDetails?.fileURL}
                fileName={castDetails.filename}
              />
            </>
          )}{' '}
        </>
      )}
    </div>
  )
}
